import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  Button, 
  Grid,
  Card,
  CardContent
} from '@mui/material';
import { Link } from 'react-router-dom';
import { 
  AssignmentTurnedIn as FormIcon,
  AdminPanelSettings as AdminIcon,
  BarChart as ChartIcon,
  Security as SecurityIcon
} from '@mui/icons-material';

const LandingPage = () => {
  return (
    <Box>
      {/* Hero-Bereich */}
      <Box 
        sx={{ 
          bgcolor: 'primary.main', 
          color: 'white',
          py: 8,
          mb: 6
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={7}>
              <Typography variant="h2" component="h1" gutterBottom>
                OSP-Therapie Fragebogen
              </Typography>
              <Typography variant="h5" paragraph>
                Evaluierung der oralen Stimulationsplatte bei Kindern im Alter von 1-14 Jahren
              </Typography>
              <Box sx={{ mt: 4 }}>
                <Button 
                  variant="contained" 
                  color="secondary" 
                  size="large"
                  component={Link}
                  to="/admin"
                  sx={{ mr: 2, mb: 2 }}
                >
                  <AdminIcon sx={{ mr: 1 }} />
                  Administration
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <Paper 
                elevation={6} 
                sx={{ 
                  p: 3, 
                  bgcolor: 'rgba(255, 255, 255, 0.9)',
                  color: 'text.primary',
                  borderRadius: 2
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Hinweis für Teilnehmer
                </Typography>
                <Typography paragraph>
                  Um den Fragebogen ausfüllen zu können, benötigen Sie einen personalisierten Link.
                  Dieser wird Ihnen per E-Mail zugesendet oder kann von Ihrem Betreuer erstellt werden.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                  Bei Fragen wenden Sie sich bitte an Ihren Ansprechpartner.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Features-Bereich */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" align="center" gutterBottom>
          Funktionen des OSP-Fragebogensystems
        </Typography>
        <Typography variant="subtitle1" align="center" color="text.secondary" paragraph sx={{ mb: 6 }}>
          Ein modernes System zur Erfassung und Auswertung von OSP-Therapiedaten
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <FormIcon color="primary" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Digitaler Fragebogen
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Einfache und benutzerfreundliche Eingabe der Therapieergebnisse durch die Teilnehmer.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <SecurityIcon color="primary" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Anonymisierte Daten
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  UUID-basierte Anonymisierung bei gleichzeitiger Nachverfolgbarkeit der Therapieergebnisse.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <AdminIcon color="primary" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Admin-Bereich
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Umfassende Verwaltung von Teilnehmern, Sessions und automatische Link-Generierung.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <ChartIcon color="primary" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Auswertungen
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Detaillierte visuelle Darstellung der Therapieergebnisse für optimale Analyse.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Footer */}
      <Box sx={{ bgcolor: 'grey.200', py: 3, mt: 'auto' }}>
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} OSP-Fragebogensystem | Alle Rechte vorbehalten
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default LandingPage;